import WaldogramConfigurator from './WaldogramConfigurator';

export default WaldogramConfigurator;
